/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactTooltip from "react-tooltip";
import {
  faHeartbeat,
  faExclamationTriangle,
  faTint,
  faTintSlash,
  faBan,
} from "@fortawesome/free-solid-svg-icons";
import { AnticoagulantIcon } from "../../constants/InterrogationConstans";

const PatientIcon = ({ id, color, name, icon, htmlContent = false, text = "" }) => {
  let typeIcon;

  switch (icon) {
    case AnticoagulantIcon.FATINT:
      typeIcon = faTint;
      break;
    case AnticoagulantIcon.FAHEARTBEAT:
      typeIcon = faHeartbeat;
      break;
    case AnticoagulantIcon.FAEXCLAMATIONTRIANGLE:
      typeIcon = faExclamationTriangle;
      break;
    case AnticoagulantIcon.FATINTSLASH:
      typeIcon = faTintSlash;
      break;
  }

  if (typeIcon === faTintSlash) {
    return (
      <div className="pt-header-info icon-align-top-cursor" data-tip data-for={id}>
        <span className="fa-layers fa-fw fa-lg" data-testid={id}>
          <FontAwesomeIcon icon={faBan} style={{ fontSize: "x-large" }} />
          <FontAwesomeIcon icon={faTint} transform="shrink-6" style={{ color }} />
          <FontAwesomeIcon icon={faBan} style={{ fontSize: "x-large" }} />
        </span>
        <ReactTooltip id={id} place="top" effect="solid" html={htmlContent}>
          {name}
        </ReactTooltip>
      </div>
    );
  }

  return (
    <div className="pt-header-info icon-align-top-cursor" data-tip data-for={id}>
      {text ? (
        <span data-testid={id}>{text}</span>
      ) : typeIcon ? (
        <FontAwesomeIcon icon={typeIcon} style={{ fontSize: "x-large", color }} />
      ) : null}
      <ReactTooltip id={id} place="top" effect="solid" html={htmlContent}>
        {name}
      </ReactTooltip>
    </div>
  );
};

export default PatientIcon;
